import React from "react";
import avia from "../../assets/icons/home/biz/avia.svg";
import bolt from "../../assets/icons/home/biz/bolt.svg";
import banks from "../../assets/icons/home/biz/banks.svg";
import cloud from "../../assets/icons/home/biz/cloud.svg";
import finance from "../../assets/icons/home/biz/finance.svg";
import gosuslugi from "../../assets/icons/home/biz/gosuslugi.svg";
import oilgas from "../../assets/icons/home/biz/oilgas.svg";
import telecoms from "../../assets/icons/home/biz/telecoms.svg";


const data = [
  {
    title: "Aвиация",
    icon: avia,
    description: "Aвиация",
    style: "w-full xl:w-[320px]",
    icon_style: "w-[36px] lg:w-[51px] lg:h-[48px]",
    text_style: "w-full xl:w-[100px]"
  },
  {
    title: "Энергeтический сектор",
    icon: bolt,
    description: "Энергeтический сектор",
    style: "w-full xl:w-[320px]",
    icon_style: "w-[21px] lg:w-[30px] lg:h-[46px]",
    text_style: "w-full xl:w-[180px]"
  },
  {
    title: "Финансы",
    icon: finance,
    description: "Финансы",
    style: "w-full xl:w-[320px]",
    icon_style: "w-[35px] lg:w-[49.08px] lg:h-[49.08px]",
    text_style: "w-full xl:w-[100px]"
  },
  {
    title: "Телекоммуникации",
    icon: telecoms,
    description: "Телекоммуникации",
    style: "w-full xl:w-[320px]",
    icon_style: "w-[37px] lg:w-[52.5px] lg:h-[45.66px]",
    text_style: "w-full "
  },
  {
    title: "Нефтегазовый сектор",
    icon: oilgas,
    description: "Нефтегазовый сектор",
    style: "w-full xl:w-[320px]",
    icon_style: "w-[36px] lg:w-[50px] lg:h-[25.38px]",
    text_style: "w-full xl:w-[180px]"
  },
  {
    title: "Банковский сектор",
    icon: banks,
    description: "Банковский сектор",
    style: "w-full xl:w-[320px]",
    icon_style: "w-[29px] lg:w-[40px] lg:h-[38.33px]",
    text_style: "w-full xl:w-[180px]"
  },
  {
    title: "Госуслуги",
    icon: gosuslugi,
    description: "Госуслуги",
    style: "w-full xl:w-[320px]",
    icon_style: "w-[43px] lg:w-[47.27px] lg:h-[50.83px]",
    text_style: "w-full xl:w-[100px]"
  },
  {
    title: "Облачные системы",
    icon: cloud,
    description: "Облачные системы",
    style: "w-full xl:w-[320px]",
    icon_style: "w-[31px] lg:w-[44px] lg:h-[31px]",
    text_style: "w-full xl:w-[180px]"
  }
]

const EffectCell = ({ title, icon, style, icon_style, text_style }) => {
  return (
    <div className={`self-stretch inline-flex justify-center items-start gap-48 mb-[40px] ${style}`}>
      <div className="inline-flex flex-col justify-center items-center gap-5">
        
        <div className="w-[70px] h-[70px] lg:w-[99px] lg:h-[99px] flex items-center justify-center">
          <div className="w-[70px] h-[70px] lg:w-[99px] lg:h-[99px] bg-white rounded-full shadow-[0px_1.5959595441818237px_3.1919190883636475px_0.7979797720909119px_rgba(202,169,140,1.00)] flex items-center justify-center">
            <div className="w-[54px] h-[54px] lg:w-[70px] lg:h-[70px] bg-[#d3aa86] rounded-full flex items-center justify-center" >
              <img src={icon} alt="" className={` object-contain content-center ${icon_style}`} />
            </div>
          </div>
        </div>

        <div className="w-full flex flex-col justify-center items-center gap-5">
          <div className={`text-center justify-start text-[#d3aa86] text-[14px] lg:text-[24px] font-bold font-['Open_Sans'] ${text_style}`}>{title}</div>
        </div>
      </div>
    </div>
  )
}

export default function HomeEfectBizHome() {
  return (
    <div className="xl:pb-[115px] flex flex-col justify-content-center items-center mt-[50px] w-full">

      <div className="w-full max-w-[320px] md:max-w-full flex justify-start items-start md:justify-center">
        
        <div className="lg:text-center text-[20px] xl:text-3xl font-extrabold font-['Open Sans'] bg-gradient-to-r from-[#6082A0] to-[#E55961] text-transparent bg-clip-text mb-[60px]">
          Влияние на бизнес
        </div>
      </div>

      <div className="grid grid-cols-2 xl:grid-cols-4 items-center w-full md:w-[700px] xl:w-full">
        {data.map((item, index) => (
          <div 
            key={index} 
            style={{ order: index % 2 === 0 ? index + 1 : index - 1 }}
          >
            <EffectCell 
              title={item.title} 
              icon={item.icon} 
              style={item.style} 
              icon_style={item.icon_style} 
              text_style={item.text_style} 
            />
          </div>
        ))}
      </div>
    </div>
  );
};
